// extracted by mini-css-extract-plugin
export default {"titleBox":"BrokeragePage_titleBox__Ue6-t"};